import { demoStore } from './store';
import type { Booking, ClientGallery, GalleryStatus, Package, Review, StudioSettings } from '../types';

export interface AdminSnapshot { galleries: ClientGallery[]; packages: Package[]; bookings: Booking[]; reviews: Review[]; settings: StudioSettings; }
export const demoMode = import.meta.env.VITE_DEMO_MODE !== 'false';

export async function adminSnapshot(): Promise<AdminSnapshot> {
  if (demoMode) return demoStore.getDb();
  const res = await fetch('/.netlify/functions/admin-api?action=snapshot', { credentials: 'include' });
  if (!res.ok) throw new Error('Unauthorized or backend unavailable');
  return res.json();
}

export async function adminAction(action: string, payload: Record<string, unknown> = {}) {
  if (demoMode) {
    const db = demoStore.getDb();
    const gallery = payload.id ? db.galleries.find(g => g.id === payload.id) : undefined;
    switch (action) {
      case 'update_gallery_status': if (gallery) gallery.status = payload.status as GalleryStatus; break;
      case 'reopen_selection': if (gallery) { gallery.selectionLocked = false; gallery.status = 'selection_open'; } break;
      case 'close_selection': if (gallery) gallery.selectionLocked = true; break;
      case 'set_archived': if (gallery) gallery.archived = Boolean(payload.archived); break;
      case 'edit_gallery': if (gallery) Object.assign(gallery, payload.patch as Partial<ClientGallery>); break;
      case 'delete_gallery': db.galleries = db.galleries.filter(g => g.id !== payload.id); break;
      case 'create_gallery': db.galleries.unshift(payload.gallery as ClientGallery); break;
      case 'duplicate_gallery': {
        const source = db.galleries.find(g => g.id === payload.id); if (source) db.galleries.unshift(payload.gallery as ClientGallery); break;
      }
      case 'update_booking_status': { const b = db.bookings.find(b => b.id === payload.id); if (b) b.status = payload.status as Booking['status']; break; }
      case 'update_package': { const p = db.packages.find(p => p.id === payload.id); if (p) Object.assign(p, payload.patch as Partial<Package>); break; }
      case 'approve_review': { const r = db.reviews.find(r => r.id === payload.id); if (r) r.approved = true; break; }
      case 'update_setting': Object.assign(db.settings, { [String(payload.field)]: payload.value }); break;
      case 'toggle_photo': { const p = gallery?.photos.find(p => p.id === payload.photoId); if (p) p.selected = !p.selected; break; }
      case 'payment_received': if (gallery) gallery.paymentStatus = 'received'; break;
      default: break;
    }
    demoStore.saveDb(db); return db;
  }
  const res = await fetch('/.netlify/functions/admin-api', { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'include', body: JSON.stringify({ action, ...payload }) });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}
